import { RtpOpaAssignment } from "../../interfaces/rtp-opa-assignment.interface";

export const rtpAssociatedOPAsSortingDataAccessor = (data: RtpOpaAssignment, sortHeaderId: string) => {
  if (sortHeaderId === 'organisationName') {
    return data[sortHeaderId].toLowerCase();
  }
  return data[sortHeaderId];
};
